module.exports = __webpack_public_path__ + "img/bad.61b36684.svg";